// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Zocy","productName":"Table_productName__2yu6U"};